import React from "react"

import { Form, Input, Button, message } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'


import {
    useLocation,
    useHistory
} from "react-router-dom"

import { AdminService } from "@/services"
import { setToken, setCurrentUser } from "@/utils"

import styles from "./styles.module.css"

function LoginPage(props) {

    const history = useHistory()
    const location = useLocation()

    const { from } = location.state || { from: { pathname: "/" } }

    const onFormSubmit = (formData) => {

        AdminService.sign_in(formData).then((response) => {
            const { status, body } = response.data

            if (status <= 0) {
                message.error(body)
                return
            }

            setToken(body.token)
            setCurrentUser(body.admin)

            message.success("登录成功")

            history.replace(from)
        })
    }

    return (
        <div className={styles.login_container}>
            <div className={styles.login_card}>
                <div className={styles.login_title}>Jowo Studio后台管理系统</div>
                <Form onFinish={onFormSubmit} className="login_form">
                    <Form.Item name="account" rules={[{ required: true, message: '请输入账号' }]}>
                        <Input
                            prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="请输入账号"
                        />
                    </Form.Item>
                    <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
                        <Input
                            prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                            type="password"
                            placeholder="请输入密码"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" block htmlType="submit" className="login_form_button">
                            登录
                         </Button>
                    </Form.Item>
                </Form>
            </div>

        </div>
    )
}

export default LoginPage